var _defs, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "cross_svg__Ebene_1",
  "data-name": "Ebene 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8.16 8.16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cross_svg__cls-1{fill:#666}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  className: "cross_svg__cls-1",
  x: 1760.43,
  y: 355.14,
  width: 1.69,
  height: 10.84,
  rx: 0.85,
  transform: "rotate(-45 452.359 2303.447)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  className: "cross_svg__cls-1",
  x: 1755.86,
  y: 359.72,
  width: 10.84,
  height: 1.69,
  rx: 0.85,
  transform: "rotate(-45 452.359 2303.447)"
})));

export default SvgCross;